module.exports = __webpack_public_path__ + "static/media/87.56fcf5c3.png";